import { FC, ReactElement, useRef, RefObject } from 'react'

import { parallaxVariables, calculateTop, calculatePosFactor } from './helper'
import { ParallaxFunctionProps } from './types'

const NonStaticParallax: FC<ParallaxFunctionProps> = (props): ReactElement => {
  const { imgData, children, classNames } = props

  const parallaxContainerRef = useRef<HTMLElement>(null)
  const parallaxImageRef = useRef<HTMLImageElement>(null)
  const parallaxContentRef = useRef<HTMLElement>(null)

  let posFactor = -0.1

  const positionObject = {
    parallaxContainer: parallaxContainerRef.current as HTMLElement,
    paralalxImage: parallaxImageRef.current as HTMLImageElement,
    parallaxContent: parallaxContentRef.current as HTMLElement,
    imgContainerHeight: parallaxContainerRef.current?.offsetHeight,
  }

  const setParallaxFields = (originalTop: number) => {
    if (positionObject && positionObject.imgContainerHeight && parallaxImageRef && parallaxImageRef.current) {
      parallaxVariables.topPosition = positionObject.parallaxContainer.getBoundingClientRect().top
      parallaxVariables.imgHt = parallaxImageRef.current.height
      positionObject.parallaxContainer.style.height = `${parallaxVariables.imgHt * 0.9}px`
      posFactor = calculatePosFactor(parallaxVariables.imgHt, originalTop, positionObject.imgContainerHeight)
    }

    parallaxVariables.topPositionNew = calculateTop(parallaxVariables.topPosition, posFactor, originalTop)
    positionObject.paralalxImage.style.top = `${parallaxVariables.topPositionNew}px`
    if (children)
      positionObject.parallaxContent.style.top = parallaxVariables.topPositionNew < 0 ? `0px` : `${parallaxVariables.topPositionNew}px`
  }

  const handleOnload = () => {
    const originalTop = Number(getComputedStyle(positionObject.paralalxImage).top.replace(/[^-0-9]/g, ''))
    setParallaxFields(originalTop)
    const page = document.querySelector('.page')
    if (page) {
      page.addEventListener('scroll', () => setParallaxFields(originalTop))

      window.addEventListener('resize', () => setParallaxFields(originalTop))
    }
  }

  return (
    <>
      <div
        ref={parallaxContainerRef as RefObject<HTMLDivElement>}
        className={`parallax-container-non-static parallax-container-common ${classNames?.banner}`}
      >
        <img
          ref={parallaxImageRef as RefObject<HTMLImageElement>}
          className={`parallax-img ${classNames?.img || ''}`}
          src={imgData.src}
          onLoad={handleOnload}
          alt={imgData.alt}
        />
        {children ? (
          <div ref={parallaxContentRef as RefObject<HTMLDivElement>} className="parallax-content">
            {children}
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  )
}

export default NonStaticParallax
